import React, { useState } from 'react';

import AddIcon from '@sats-group/icons/24/add';
import Button from '@sats-group/ui-lib/react/button';
import HiddenInput from '@sats-group/ui-lib/react/hidden-input';
import useClickOutside from '@sats-group/ui-lib/react/hooks/use-click-outside';
import Text from '@sats-group/ui-lib/react/text';
import TextInput from '@sats-group/ui-lib/react/text-input';

import Spinner from '../spinner/spinner';

import type { DiscountCode as Props } from './discount-code.props';

const DiscountCode: React.FunctionComponent<Props> = ({
  endpoint,
  gatekeeperText,
  helpText,
  hiddenInputs = [],
  label,
  name,
  submitButtonText,
}) => {
  const [isClicked, setIsClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const ref = React.useRef<HTMLDivElement>(null);

  const handleSubmit = (e: React.ChangeEvent<HTMLFormElement>) => {
    if (isLoading) {
      e.preventDefault();
    }

    setIsLoading(true);
  };

  useClickOutside(ref, () => {
    setIsClicked(false);
  });

  return (
    <div className="discount-code" ref={ref}>
      {isLoading ? <Spinner theme={Spinner.themes.overlay} /> : null}
      {isClicked ? (
        <form action={endpoint} method="POST" onSubmit={handleSubmit}>
          {hiddenInputs.map(input => (
            <HiddenInput key={input.name} {...input} />
          ))}
          <div className="discount-code__input">
            <TextInput
              type="text"
              name={name}
              label={label}
              required={true}
              helpText={helpText}
            />
            <Button
              type="submit"
              disabled={isLoading}
              data-testid={name}
              text={submitButtonText}
              size={Button.sizes.small}
            />
          </div>
        </form>
      ) : (
        <button
          className="discount-code__initial-state"
          onClick={() => setIsClicked(true)}
          data-test-discount-code-initial-state
        >
          <Text>{gatekeeperText}</Text>
          <AddIcon />
        </button>
      )}
    </div>
  );
};

export default DiscountCode;
